window.addEventListener('DOMContentLoaded', () => {
    var $carousel = $('.gallery-slick');
    var $zoomCarousel = $('.product-media-modal__content');

    $carousel.slick({
        centerMode: false,
        infinite: true,
        slidesToShow: 1,
        centerPadding: '0px',
        dots: true,
        prevArrow: '.swiper-button-prev',
        nextArrow: '.swiper-button-next',
        arrows: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1601,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0,
                    centerMode: false,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    initialSlide: 0,
                    arrows: false,
                    centerMode: false,
                }
            }
        ]
    });

    if($carousel.slick('getSlick').slideCount == 1) {
        $carousel.slick('slickGoTo', 0);
    }

    $(document).on('keydown', function(e) {
        if(e.keyCode == 37) {
            $carousel.slick('slickPrev');
        }
        if(e.keyCode == 39) {
            $carousel.slick('slickNext');
        }
    });

    // if one click (not swapped), simulates click on .product__media-toggle
    $carousel.on('click', '.slick-slide', function(e) {
        var index = $(this).data('slick-index');
        $zoomCarousel.slick('slickGoTo', index);
        $(this).find('.product__media-toggle')[0].click();
    });
});